import React from 'react'
import "./footer.css"
import { Link, useNavigate } from 'react-router-dom'
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import useWindowDimensions from '../../customHooks/useWindowDimensions';
import { useSelector } from 'react-redux';

function Footer() {
    const navigate = useNavigate()
    const isLogin = useSelector(state => state.login?.isLogin)
    const { height, width } = useWindowDimensions();
  return (
    <div className='footer'>
        <div className='video-wp'>
        <video src="../../../vid/math_patterns.mp4" className='footer-video' muted autoPlay loop playsInline >
Your browser does not support the video tag.
</video>
        </div>
        <div className='content-wp'>
    <div className='footer-brandng-wp'>
        <div className='brand-wp'>
            <img className='brand-img' src='../../../img/brand_logo_icon.webp' />
            {/* <div className='brand-name-wp'>
                <p>global trade</p>
                <p>academy.com</p>
            </div> */}
        </div>
        <div className='slogan'>
        <p >"Will help you master core concepts and train your brain to tackle any type of DSA problem encountered in an interview!"</p>
        {!isLogin && <p >Enroll now and start your journey to success!</p>}
        </div>
    </div>
    <div className='footer-link-wp'>
        <div className='part1'>
                <span className='link' onClick={()=>navigate("/termandcond")}>Terms & Conditions</span>
                <span className='link' onClick={()=>navigate("/refundpolicy")}>Refund Policy</span>
                <span className='link' onClick={()=>navigate("/contact")}>Contact Us</span>


        </div>
        <div className='part2'>
            <Link>
                <span>
                <InstagramIcon />
                </span>
            </Link>
            <Link>
                <span>
                <TwitterIcon />
                </span>
            </Link>
            {width > 450 && <Link>
                <span>
                <FacebookIcon />
                </span>
            </Link>}
            {width > 400 && <Link>
                <span>
                <YouTubeIcon />
                </span>
            </Link>}
        </div>
    </div>
</div>
    </div>
  )
}

export default Footer